Namespace 'Customer.Filters'

class Customer.Filters.EditFilterGeneralTabView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/general/edit_filter_general_tab']
  className: 'filter-general-container d-flex flex-column align-items-center'

  initialize: ({filter, query, canManageGlobal, editable, availableFolders, usersGroups}) ->
    @mainConfigCardView = new Customer.Filters.MainConfigCardView({
      filter
      query
      canManageGlobal
      editable
    })
    @datePickerCardView = new Customer.Filters.DatePickerCardView({filter})
    @foldersCardView = new Customer.Filters.FoldersCardView({
      initialSelectedFolder: filter.get('filter_collection_id')
      availableFolders
    })
    @visibleByCardView = new Customer.Filters.VisibleByCardView({filter, editable, usersGroups})
    @visibleByStatusCardView = new Customer.Filters.VisibleByStatusCardView({filter, editable})

    @listenTo(@mainConfigCardView, 'filter:toggleVisibility', @_onToggleVisibility)

  render: ->
    @$el.html @template
    @$el.find('.main-config-card').html(@mainConfigCardView.render().el)
    @$el.find('.date-picker-card').html(@datePickerCardView.render().el)
    @$el.find('.visibility-filters-container').append(@visibleByStatusCardView.render().el)
    @$el.find('.visibility-filters-container').append(@visibleByCardView.render().el)
    @$el.find('.general-filters-container').append(@foldersCardView.render().el)
    @

  getColor: =>
    @mainConfigCardView.getColor()

  getDateRange: =>
    @datePickerCardView.getDateRange()

  getFilterTitle: =>
    @mainConfigCardView.getFilterTitle()

  getVisibility: =>
    @mainConfigCardView.getVisibility()

  getSelectedFolder: =>
    @foldersCardView.getSelectedFolder()

  getVisibleBy: =>
    @visibleByCardView.getVisibleBy()

  getVisibleByStatuses: =>
    @visibleByStatusCardView.getVisibleByStatuses()

  _onToggleVisibility: (isPublic) =>
    @trigger('filter:toggleVisibility', isPublic)
    @visibleByCardView.toggle(isPublic)

  showErrors: (errors) =>
    @mainConfigCardView.showErrors(errors)

  cleanErrors: =>
    @mainConfigCardView.cleanErrors()

  updateAvailableFolders: (availableFolders) ->
    @foldersCardView.updateAvailableFolders(availableFolders)
    @foldersCardView.render()

  closeColorPicker: ->
    @mainConfigCardView.closeColorPicker()
